module.exports = __webpack_public_path__ + "static/flowerorganicmuslin-a33c8e1ca744566894f6926e3330ea61.jpeg";